var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{ref:"audio",staticClass:"audio-player",attrs:{"src":_vm.url,"preload":"metadata"},on:{"error":_vm.error,"ended":_vm.ended}})}
var staticRenderFns = []

export { render, staticRenderFns }